import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

import { Easing } from '@picsart/design-system/foundation/easing';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';

const useStyles = createUseStyles(
  () => ({
    root: {
      paddingTop: Spacings.s56,
      paddingBottom: Spacings.s56,
      overflow: 'hidden',

      [BreakPointsMedia.LG]: {
        paddingTop: Spacings.s44,
        paddingBottom: Spacings.s44,
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        paddingTop: Spacings.s40,
        paddingBottom: Spacings.s40,
      },
    },
    titleWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      margin: [Spacings.s0, 'auto', Spacings.s48],

      '&:before, &:after': {
        content: "''",
        backgroundColor: BackgroundColors.base,
        maxWidth: 546,
        display: 'inline-block',
        width: '-webkit-fill-available',
        height: 2,

        // [mediaQuery(BreakPoints.Small)]: {
        '@media screen and (max-width: 766px)': {
          display: 'none',
        },
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        margin: [Spacings.s0, 'auto', Spacings.s32],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        margin: [Spacings.s0, 'auto', Spacings.s24],
      },
    },
    title: {
      fontWeight: FontWeights.semibold,
      color: TextColors.tint1,
      fontSize: FontSizes.s30,
      margin: [Spacings.s0, 'auto'],
      whiteSpace: 'nowrap',
      padding: [Spacings.s0, Spacings.s40],
      lineHeight: LineHeights.l36,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l48,
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l28,
      },
    },
    cardsWrapper: {
      '--gap': Spacings.s24,

      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      margin: [Spacings.s0, 'calc(-1 * var(--gap))', 'calc(-1 * var(--gap))', Spacings.s0],
      width: 'calc(100% + var(--gap))',
      scrollBehavior: 'smooth',

      '& > *': {
        margin: [Spacings.s0, 'var(--gap)', 'var(--gap)', Spacings.s0],
      },
      '&::-webkit-scrollbar': {
        display: 'none',
      },

      // // [mediaQuery(BreakPoints.Small)]: {
      // '@media screen and (max-width: 766px)': {
      //   justifyContent: 'space-between',
      // },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        justifyContent: 'space-between',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'scroll',
      },
    },
    buttonLearnMore: {
      maxWidth: 200,
      margin: [Spacings.s44, 'auto', Spacings.s0],
      transition: `color ${Timings.default} ${Easing.easeInOut}`,
      '& > span': {
        borderRadius: CornerRadius.r8,
        textAlign: 'center',
        padding: [Spacings.s16, Spacings.s24],
        lineHeight: LineHeights.l24,
        fontSize: FontSizes.s16,
        fontWeight: FontWeights.medium,
        width: '100%',
      },
      [BreakPointsMedia.LG]: {
        margin: [Spacings.s40, 'auto', Spacings.s0],
      },
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        // maxWidth: 456,
        maxWidth: '100%',
        '& > a.buttonLearnMore': {
          maxWidth: 456,
        },
        '&:not(a.buttonLearnMore)': {
          margin: [Spacings.s40, 'auto', Spacings.s0],
        },
      },
      // // [mediaQuery(766)]: {
      // '@media screen and (max-width: 766px)': {
      //   maxWidth: '100%',
      // },
    },
    // Skeleton
    skeleton: {
      maxWidth: 1080,
      margin: [Spacings.s0, 'auto'],
    },
    skeletonContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    skeletonTitle: {
      height: 46,
      marginBottom: Spacings.s56,
    },
    skeletonCard: {
      width: 196,
      height: 230,
    },
    skeletonButton: {
      width: 198,
      height: 56,
      margin: [Spacings.s44, 'auto'],
    },
  }),
  {
    name: 'apps-card',
  },
);

export default useStyles;
